import React, { useEffect } from "react";
import styled from "styled-components";
import intl from "react-intl-universal";

import { useInput } from "../../../hooks/useInput";
import { Checkbox } from "../../../components/Checkbox";
import { SelectSingle } from "../../../components/SelectSingle";

const RowContainerStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
`;

const AreaNameStyle = styled.div`
    flex: 1;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
`;

const InputsWrapperStyle = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 16px;
    margin-left: auto;
`;

const SelectSlicesWrapperStyle = styled.div`
    width: 80px;
`;

export const ReportAreaItem = props => {
    const { wattwaechterResult, worstcaseResult, onChange, area} = props;
    const areaId = area.id;

    const worstcaseInput = useInput(`wc-${areaId}`, Boolean(worstcaseResult));
    const wattwaechterInput = useInput(`ww-${areaId}`, Boolean(wattwaechterResult));
    const sliceInput = useInput(`sliceInput-${areaId}`, 0);
    const fieldMaxInput = useInput(`fieldMax-${areaId}`, false);

    useEffect(() => {
        onChange(area, worstcaseInput.value, wattwaechterInput.value, sliceInput.value, fieldMaxInput.value);
    },[sliceInput.value, fieldMaxInput.value, worstcaseInput.value, wattwaechterInput.value]);

    const numberW = Math.min(wattwaechterResult?.numberW ?? 1000, worstcaseResult?.numberW ?? 1000);

    // Generate slice options from 0 to numberW - 1
    const sliceOptions = Array.from({ length: numberW }, (_, i) => i);

    return (
        <RowContainerStyle>
            <AreaNameStyle>
                {area?.name ?? ""}
            </AreaNameStyle>
            <InputsWrapperStyle>
                <div style={{ visibility: worstcaseResult ? "visible" : "hidden" }}>
                    <Checkbox
                        {...worstcaseInput.bind}
                        title={intl.get("entry.report.wcLabel")}
                    />
                </div>
                <div style={{ visibility: wattwaechterResult ? "visible" : "hidden" }}>
                    <Checkbox
                        {...wattwaechterInput.bind}
                        title={intl.get("entry.report.wwLabel")}
                    />
                </div>
                <div style={{ visibility: (wattwaechterResult || worstcaseResult) ? "visible" : "hidden" }}>
                    <SelectSlicesWrapperStyle>
                        <SelectSingle
                            {...sliceInput.bind}
                            title={intl.get("entry.report.sliceSelect")}
                            disabled={numberW <= 0 || fieldMaxInput.value}
                            toLabel={value => `${value}`}>
                            {sliceOptions.map(sliceNum => (
                                <option key={sliceNum} value={sliceNum}>
                                    {`${sliceNum}`}
                                </option>
                            ))}
                        </SelectSingle>
                    </SelectSlicesWrapperStyle>
                </div>
                <div style={{ visibility: wattwaechterResult ? "visible" : "hidden" }}>
                    <Checkbox
                        {...fieldMaxInput.bind}
                        title={intl.get("entry.report.fieldMax")}
                    />
                </div>
            </InputsWrapperStyle>
        </RowContainerStyle>
    );
};
